/**
 * @generated SignedSource<<45362ad98565eaa0b48671d6bcd2d892>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProductizedServiceType = "BUY_NOW_INSTANT_PURCHASE" | "BUY_NOW_OTHER" | "BUY_NOW_REQUEST" | "NOT_PURCHASABLE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type EmbedBuyNowCTA_productizedService$data = {
  readonly productizedServiceType: ProductizedServiceType | null;
  readonly slug: string;
  readonly " $fragmentType": "EmbedBuyNowCTA_productizedService";
};
export type EmbedBuyNowCTA_productizedService$key = {
  readonly " $data"?: EmbedBuyNowCTA_productizedService$data;
  readonly " $fragmentSpreads": FragmentRefs<"EmbedBuyNowCTA_productizedService">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmbedBuyNowCTA_productizedService",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "productizedServiceType",
      "storageKey": null
    }
  ],
  "type": "ProductizedService",
  "abstractKey": null
};

(node as any).hash = "45b3a131ebca5778d323f68698dde845";

export default node;
